import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=905e75c6&"
import script from "./AddQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports